var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"foot"},[_vm._v("本系统由德阳指尖秘码科技有限公司提供技术支持")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }